import { TOUR_TARGETS } from "../config/target-registry";
import type { TourTargetKey } from "../types/tour.types";

const isUsableTarget = (element: Element | null): element is HTMLElement => {
  if (!(element instanceof HTMLElement)) return false;
  if (!element.isConnected) return false;
  const rect = element.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return false;
  const style = window.getComputedStyle(element);
  return style.visibility !== "hidden" && style.display !== "none";
};

export const resolveTargetElement = (
  primary: TourTargetKey,
  fallbacks: TourTargetKey[] = [],
): HTMLElement | null => {
  for (const key of [primary, ...fallbacks]) {
    const matches = document.querySelectorAll(TOUR_TARGETS[key]);
    for (const element of Array.from(matches)) {
      if (isUsableTarget(element)) return element;
    }
  }
  return null;
};

export const createTargetGetter =
  (primary: TourTargetKey, fallbacks: TourTargetKey[] = []) =>
  (): HTMLElement | null =>
    resolveTargetElement(primary, fallbacks);
